import React from "react";
import { Link } from "react-router-dom";
import { Star, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { resolveImg, inr } from "../lib/api";
import { useCart } from "../context/CartContext";

const Stars = ({ rating }) => (
  <div className="flex items-center gap-1">
    <div className="flex">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={14}
          className={i <= Math.round(rating) ? "fill-[#C5A059] text-[#C5A059]" : "text-[#D8CFC0]"}
        />
      ))}
    </div>
  </div>
);

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    addItem(product);
    toast.success(`${product.name} added to cart`);
  };

  const discount =
    product.price_original > product.price_discounted
      ? Math.round(((product.price_original - product.price_discounted) / product.price_original) * 100)
      : 0;

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group bg-white rounded-2xl overflow-hidden border border-[#E2DAD0] hover-lift flex flex-col"
    >
      <div className="relative aspect-square bg-[#FAF7F2] overflow-hidden">
        {product.bestseller && (
          <span
            className="absolute top-3 left-3 z-10 bg-[#1F4D2E] text-[#F5F0E6] text-[10px] font-bold tracking-wider px-2.5 py-1 rounded-full"
            data-testid="bestseller-badge"
          >
            BESTSELLER
          </span>
        )}
        {discount > 0 && (
          <span className="absolute top-3 right-3 z-10 bg-[#C5A059] text-white text-[10px] font-bold px-2 py-1 rounded-full">
            {discount}% OFF
          </span>
        )}
        <img
          src={resolveImg(product.image_url)}
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-semibold text-[15px] text-[#1C2B20] leading-snug line-clamp-2 min-h-[42px]">
          {product.name}
        </h3>
        <div className="mt-2 flex items-center gap-1.5">
          <Stars rating={product.rating} />
          <span className="text-xs text-[#8A9A8D]">({product.reviews_count})</span>
        </div>
        <div className="mt-3 flex items-center gap-2">
          <span className="text-lg font-bold text-[#1F4D2E]">{inr(product.price_discounted)}</span>
          {product.price_original > product.price_discounted && (
            <span className="text-sm text-[#9E9E9E] line-through">{inr(product.price_original)}</span>
          )}
        </div>
        <button
          onClick={handleAdd}
          data-testid={`add-to-cart-${product.id}`}
          className="mt-4 w-full flex items-center justify-center gap-2 bg-[#1F4D2E] hover:bg-[#163A22] text-white text-sm font-medium rounded-full py-2.5 transition-colors"
        >
          <ShoppingCart size={16} /> Add to Cart
        </button>
      </div>
    </Link>
  );
};

export default ProductCard;
export { Stars };
